/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlanLength/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import LockAction from './LockAction/index'
import React from 'react'
import Slider from 'DesignSystem/Slider/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlanLength({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/New/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/PaymentPlanLength"
  
}) {
let payorPaymentPlanLengthValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'payment_plan_length',
})
let payorLockValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'lock',
})
let payorInstallmentAmountValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'installment_amount',
})
let aggregateData = fromHelpers.isDisabled(payorLockValueData, payorInstallmentAmountValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let payorPaymentPlanLengthValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'payment_plan_length',
})
let payorLockValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'lock',
})
let payorInstallmentAmountValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'installment_amount',
})
let aggregateData1 = fromHelpers.isDisabled(payorLockValueData1, payorInstallmentAmountValueData1)
let settingsMaximumPaymentPlanLengthValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'maximum_payment_plan_length',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let onChange1 = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Installment length"
 marginTop={0}
/>
<div
  data-testid="PaymentPlanLength.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="number"
 marginTop={dtSpaceXxs}
 maxWidth={200}
 data="payor.payment_plan_length"
 value={payorPaymentPlanLengthValueData}
 onChange={onChange}
 data="payor.lock"
 data="payor.installment_amount"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<Slider
  viewPath={`${viewPath}/Slider`}
 data="payor.payment_plan_length"
 value={payorPaymentPlanLengthValueData1}
 onChange={onChange1}
 data="payor.lock"
 data="payor.installment_amount"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData1}
 width="auto"
 marginLeft={dtSpaceS}
 marginTop={dtSpaceLs}
 flexGrow={1}
 flexShrink={1}
 flexBasis="auto"
 tabIndex={-1}
 backgroundColor={dtColorsNeutral300}
 backgroundColorThumb={dtColorsBrandBase}
 backgroundColorThumbDisabled={dtColorsNeutral400}
 boxShadowThumb="0px 4px 12px 0px dt.colors.neutral.400"
 heightThumb={26}
 widthThumb={26}
 dataType="integer"
 min={0}
 data="settings.maximum_payment_plan_length"
 max={settingsMaximumPaymentPlanLengthValueData}
 step={1}
 onMixMaxLabelFormatter={fromHelpers.formatPaymentPlanLength}
/>
<LockAction
  viewPath={`${viewPath}/LockAction`}
/>
</div>
{children}
</React.Fragment>)
}